import React from 'react'
import { IOrderItem } from 'orders/schema'
import ItemSection from './components/itemSection'
import SectionDataGrid from './components/sectionDataGrid'
import './styles.scss'
import { useTranslation } from 'translations'

const ItemCancelationRefundSection = ({
    item,
    accountSlug,
    isItemSelected,
}: {
    item: IOrderItem
    accountSlug: string
    isItemSelected: boolean
}) => {
    const { t } = useTranslation()
    const detailsData = React.useMemo(
        () => [
            { name: t('orders.orders.orderDetails.canceled.canceledBy'), value: item.refundInfo?.requestedBy },
            { name: t('orders.orders.orderDetails.canceled.reason'), value: item.refundInfo?.reason },
        ],
        [item, accountSlug, t],
    )

    return (
        <ItemSection sectionName={t('orders.orders.orderDetails.canceled.title')} isItemSelected={isItemSelected} isItemCanceledRefunded={true}>
            <SectionDataGrid dataItems={detailsData} />
        </ItemSection>
    )
}

export default ItemCancelationRefundSection
